export default __webpack_public_path__ + "static/media/Read-Regular_V1100.981d3164.woff2";